import { Component } from '@theme/component';

class ShadeGrid extends Component {
  #activeTone = 'naturel';

  handleFilter(data, event) {
    const tone = data.tone;
    if (tone === this.#activeTone) return;
    this.#activeTone = tone;

    // Update pill active states
    this.refs.pills.forEach((pill) => {
      const isActive = pill.dataset.tone === tone;
      pill.classList.toggle('shade-grid__pill--active', isActive);
      pill.setAttribute('aria-selected', String(isActive));
    });

    // Toggle filtered class (hides group labels when single tone selected)
    this.classList.toggle('shade-grid--filtered', tone !== 'all');

    // Show/hide groups
    this.refs.groups.forEach((group) => {
      group.hidden = tone !== 'all' && group.dataset.tone !== tone;
    });

    // Re-apply stagger animation indexes
    let i = 0;
    this.refs.groups.forEach((group) => {
      if (group.hidden) return;
      group.querySelectorAll('.shade-grid__swatch').forEach((swatch) => {
        swatch.style.setProperty('--swatch-index', i++);
        swatch.classList.remove('shade-grid__swatch--appear');
        // Force reflow to restart animation
        void swatch.offsetWidth;
        swatch.classList.add('shade-grid__swatch--appear');
      });
    });
  }
}

customElements.define('shade-grid-component', ShadeGrid);
